import { mapWorkingLogToApplicantRow } from "./timesheetApiMappers";

export const normalizeTimesheetApplicantId = (id) =>
  id == null || id === "" ? null : String(id);

export const getTimesheetApplicantName = (row, lang) => {
  const user = row?.user || row;

  if (lang === "en" && user?.full_name_en?.trim()) {
    return user.full_name_en;
  }

  if (lang === "ar" && user?.full_name_ar?.trim()) {
    return user.full_name_ar;
  }

  return user?.full_name_en || user?.full_name_ar || user?.name || "-";
};

export const resolveTimesheetApplicantBreadcrumbLabel = ({
  applicantId,
  workingLogs,
  shiftsList,
  lang,
}) => {
  const normalizedId = normalizeTimesheetApplicantId(applicantId);
  if (!normalizedId) {
    return null;
  }

  const fromList = (workingLogs || [])
    .map(mapWorkingLogToApplicantRow)
    .find((row) => normalizeTimesheetApplicantId(row.id) === normalizedId);

  if (fromList) {
    return getTimesheetApplicantName(fromList, lang);
  }

  const slotWithUser = (shiftsList || []).find((row) => {
    const rowId = normalizeTimesheetApplicantId(
      row?.working_log_id ?? row?.working_log?.id ?? row?.id,
    );
    return rowId === normalizedId && row?.user;
  });

  if (slotWithUser?.user) {
    return getTimesheetApplicantName({ user: slotWithUser.user }, lang);
  }

  return null;
};

export const resolveCheckoutStatus = (row) => {
  if (!row?.check_out_at) {
    return "pending";
  }

  return row.is_checked_out_automatically ? "auto" : "self";
};
